module.exports = __webpack_public_path__ + "connection_2.94efa3df47f5e5a265f5f402b6deaded.svg";